/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { PLACEHOLDER_IMAGE_URL } from "../../../../app/mock/constants";
import { useAuth } from '../../../../app/modules/auth';
import imgBaseUrl from '../../../../app/utils/imgBaseUrl';

const HeaderUserMenu: FC = () => {
  const { currentUser, logout } = useAuth()
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img className={"object-fit-cover"} alt='Logo' src={imgBaseUrl(currentUser?.avatar!) || PLACEHOLDER_IMAGE_URL} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {currentUser?.first_name} {currentUser?.last_name}
              <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>{currentUser?.role?.toUpperCase()}</span>
            </div>
            <span className='fw-bold text-muted text-hover-primary fs-7'>
              {currentUser?.phone || currentUser?.email}
            </span>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link to={'/profile'} className='menu-link px-5'>
          Mening profilim
        </Link>
      </div>

      <div className='separator my-2'></div>

      {/*<Languages />*/}

      <div className='menu-item px-5 my-1'>
        <Link to='/settings' className='menu-link px-5'>
          Sozlanmalar
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Chiqish
        </a>
      </div>
    </div>
  )
}

export { HeaderUserMenu };

